const euros = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
});

// « 1 234,50 € »
export const formatAmount = (amount: number): string => euros.format(amount);
